import popMessageReducer from "./popMessageReducer";

export const popMessageReducers = {
  popMessage: popMessageReducer,
};
